export var MIN_NOTE_AMOUNT = 0.01;
export var INVOICE_START_DATE_DURATION = 6;
export var DEBIT_NOTE = 'Debit Note';
export var INVOICE = 'Invoice';